import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safehtml'
})
export class SafehtmlPipe implements PipeTransform {
  sanitizer: any;
  constructor(private sanitized: DomSanitizer) { }

  transform(html: any): any {
    // const styledHtml = html.replace(/<a /g, '<a style="text-decoration: none;" ');
    return this.sanitized.bypassSecurityTrustHtml(html);
    // return styledHtml;
  }
}

@Pipe({
  name: 'safeNotice', // New pipe name
})
export class SafeNoticePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
